/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SourceDialog extends SiteEntityDialog<SourceRow, any> {
        protected getFormKey() { return SourceForm.formKey; }
        protected getIdProperty() { return SourceRow.idProperty; }
        protected getLocalTextPrefix() { return SourceRow.localTextPrefix; }
        protected getNameProperty() { return SourceRow.nameProperty; }
        protected getService() { return SourceService.baseUrl; }

        protected form = new SourceForm(this.idPrefix);

    }
}